import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useI18n } from "@/i18n";

export const Reviews = ({ variant = "light" }) => {
  const { t } = useI18n();
  const REVIEWS = t.reviews.items;
  const [index, setIndex] = useState(0);
  const dark = variant === "dark";

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % REVIEWS.length);
    }, 11000);
    return () => clearInterval(id);
  }, []);

  const review = REVIEWS[index];

  const overlineCls = dark ? "text-canvas/60" : "";
  const quoteIconCls = dark ? "text-brand-red/50" : "text-brand-red/40";
  const quoteTextCls = dark ? "text-canvas" : "text-ink";
  const authorCls = dark ? "text-canvas/60" : "text-ink-muted";
  const dotInactive = dark
    ? "bg-canvas/25 hover:bg-canvas/50"
    : "bg-ink/20 hover:bg-ink/40";

  return (
    <div data-testid="reviews-carousel" className="relative">
      <div className="flex items-center gap-3 mb-8">
        <p className={`overline ${overlineCls}`}>{t.reviews.overline}</p>
        <span className="flex items-center gap-0.5" aria-hidden="true">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star
              key={i}
              size={13}
              strokeWidth={1.2}
              className="fill-brand-red text-brand-red"
            />
          ))}
        </span>
      </div>

      <div className="relative min-h-[240px] md:min-h-[220px]">
        <Quote
          size={28}
          strokeWidth={1}
          className={`${quoteIconCls} mb-4`}
          aria-hidden="true"
        />
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={index}
            data-testid={`review-${index}`}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -14 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className={`serif italic text-xl md:text-2xl leading-relaxed ${quoteTextCls}`}>
              „{review.quote}"
            </p>
            <footer className={`mt-6 text-sm tracking-[0.2em] uppercase ${authorCls}`}>
              {review.author}
            </footer>
          </motion.blockquote>
        </AnimatePresence>
      </div>

      <div className="flex items-center gap-3 mt-8" role="tablist" aria-label="Opinie gości">
        {REVIEWS.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setIndex(i)}
            data-testid={`review-dot-${i}`}
            aria-label={`Pokaż opinię ${i + 1}`}
            aria-selected={i === index}
            className={`h-2.5 rounded-full transition-all duration-500 ${
              i === index ? "w-8 bg-brand-red" : `w-2.5 ${dotInactive}`
            }`}
          />
        ))}
      </div>
    </div>
  );
};
